import Vue from "vue";
import Router from "vue-router";
// import Index from '@/components/Index'
// import Posts from '@/components/Posts'
import Login from "../components/Login";
import Dashboard from "../components/Dashboard";
import Profile from "../components/Profile";
import QARecord from "../components/QARecords.vue";
import Log from "../components/Log.vue";
import QAEdit from "../components/QAEdit.vue";
import Categories from "../components/Categories.vue";
import GenerateWidget from "../components/GenerateWidget.vue";
import Agents from "../components/Agents.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Dashboard",
      component: Dashboard
    },
    {
      path: "/login/:dbName",
      name: "Logindb",
      component: Login
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/qarecord",
      name: "QARecord",
      component: QARecord
    },
    {
      path: "/log",
      name: "Log",
      component: Log
    },
    {
      path: "/qaedit/:id_question",
      name: "QAEdit",
      component: QAEdit
    },
    {
      path: "/categories",
      name: "Categories",
      component: Categories
    },
    {
      path: "/generateWidget",
      name: "Generate Widget",
      component: GenerateWidget
    },
    {
      path: "/agents",
      name: "Agents",
      component: Agents
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js